import * as React from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import FilesListItem from "./FilesListItem";
import { FileInfo } from "./FileInfo";

export interface FilesListProps {
    items: Array<FileInfo>;
    removeFile: (fileInfo: FileInfo) => void;
}

type PropsType = FilesListProps;

class FilesList extends React.PureComponent<PropsType> {

    render() {
        const { items, removeFile } = this.props;

        return <div>
            <Table padding="checkbox">
                <TableBody>
                    {items.map((v, k) => <FilesListItem key={k} item={v} removeFile={removeFile} />)}
                </TableBody>

            </Table>
        </div>;

    }
}

export default FilesList;